/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { ArrowsUpDownIcon } from "@heroicons/react/24/outline";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { useCallback, useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";

import { SubmitButton as Button } from "~/components/form/submit-button";
import {
  getExtraction,
  TGESMETaskLockResponse,
} from "~/services/supervisor.services";
import { formatDate } from "~/utils/basic";
import { toast } from "react-toastify";
import ResponseModal from "~/components/pages/agent/document-declaration/TGEPE/modals/response-modal";
import { convertSecondsToHHMMSS } from "~/utils/basic";
interface ISupervisorTableProps {
  data: any[];
  onSubmit: () => void;
}

const ExtractionTable = ({ data, onSubmit }: ISupervisorTableProps) => {
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  }>({
    key: "ReceivedOnServer",

    direction: "desc",
  });

  type SelectedRowIds = Record<string, boolean>;

  const params = new URLSearchParams(window.location.hash.split("?")?.[1]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [filters, setFilters] = useState<Record<string, string[]>>({
      SourceBranch: [params.get('SourceBranch') || ''],
      State: [params.get('State') || '']
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [selectedRowIds, setSelectedRowIds] = useState<SelectedRowIds>({});

  const [loading, setLoading] = useState(false);

  const [tableData, setTableData] = useState(data);
  const columnHelper = createColumnHelper<any>();
  const [allData] = useState<any[]>(data);

  const [selectedTaskId, setSelectedTaskId] = useState<string | null>(null);

  const [respondModal, setRespondModal] = useState<boolean>(false);
  const [dateRange] = useState<{
    fromDate: string;
    toDate: string;
  } | null>(null);
  const [searchInputs, setSearchInputs] = useState<Record<string, string>>({
      SourceBranch: params.get('SourceBranch') || '',
      State: params.get('State') || ''
  });

  const location = useLocation();
  const navigate = useNavigate();
  const roleid = localStorage.getItem("roleid") as string;

  if (!sessionStorage.getItem("prevPath")) {
    sessionStorage.setItem("prevPath", location.pathname);
  }

  const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const debouncedSetFilters = useCallback(
    debounce((value: string, key: string) => {
      setFilters((prev) => ({
        ...prev,
        [key]: [value],
      }));
    }, 0),
    []
  );
  useEffect(() => {
    setTableData(data);
  }, [data]);
  const closeRespondModal = () => {
    setRespondModal(false);
  };

  const openRespondModal = (taskId: string) => {
    setSelectedTaskId(taskId);
    setRespondModal(true);
  };

  const checkTaskLockResponse = async (
    taskId: string,
    shouldNavigate: boolean
  ): Promise<boolean> => {
    try {
      // Make the request and destructure the response
      //const { response, error } = await TGESMETaskLockResponse(taskId);

      const result = await TGESMETaskLockResponse(taskId, roleid);
      const { response, error } = result as {
        response: { data: string; message: string; status: number };
        error: string | null;
      };

      if (error) {
        // Handle error from the API call
        toast.error("Error while checking task lock.");
        return false;
      }

      const parsedData = JSON.parse(response?.data);
      const status = parsedData[0]?.status;
      const message = parsedData[0]?.message;

      if (status === "success") {
        if (shouldNavigate) {
          // Navigate if shouldNavigate is true (for the Edit button)
          const path = `/supervisor/worklist/edit/${taskId}`;
          navigate({ to: path, params: { taskId: taskId } });
        }
        return true;
      } else {
        toast.error(message);
        return false; // Return false if task is locked or there's another issue
      }
    } catch (e) {
      // Catch any unexpected errors
      console.error("Unexpected error: ", e);
      toast.error("An unexpected error occurred.");
      return false; // Return false in case of an error
    }
  };

  const handleRespondClick = async (taskId: string) => {
    const isTaskNotLocked = await checkTaskLockResponse(taskId, false); // No navigation for Respond

    if (isTaskNotLocked) {
      // Open the modal if the task is not locked
      openRespondModal(taskId);
    }
  };

  useEffect(() => {
    const filtered = data.filter((row) =>
      Object.entries(filters).every(([key, searchValues]) => {
        const values = Array.isArray(searchValues)
          ? searchValues
          : [searchValues];
        return values.some((value) => {
          if (dynamicColumns.includes(key)) {
            return convertSecondsToHHMMSS(row[key]).includes(value);
          }
          if (value === "") {
            return true;
          }
          return row[key]
            ?.toString()
            .toLowerCase()
            .includes(value?.toLowerCase());
        });
      })
    );
    setFilteredData(filtered);
    setCurrentPage(0);
    setSelectedRowIds({})
  }, [filters, data]);

  const fetchExtractionData = async () => {
    if (dateRange) {
      setLoading(true);
      const { fromDate, toDate } = dateRange;

      const { data, status } = await getExtraction(fromDate, toDate);
      setLoading(false);
      if (status) {
        setTableData((data as any)?.data);

        setFilters({});
        setSearchInputs({});

        console.log("refreshed");
        setCurrentPage(0);
      } else {
        console.error("Failed to fetch extraction data.");
      }
    }
  };
  useEffect(() => {
    fetchExtractionData();
  }, [dateRange]);

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(0);
  };

  const requestSort = useCallback((key: string) => {
    setSortConfig((prevConfig) => {
      let direction: "asc" | "desc" = "asc";
      if (prevConfig.key === key && prevConfig.direction === "asc") {
        direction = "desc";
      } else if (prevConfig.key === key && prevConfig.direction === "desc") {
        direction = "asc";
      }
      return { key, direction };
    });
  }, []);

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;

    const sortableItems = [...filteredData];
    sortableItems.sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue < bValue) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
      return 0;
    });

    return sortableItems;
  }, [filteredData, sortConfig]);

  const paginatedData = useMemo(() => {
    const start = currentPage * rowsPerPage;
    const end = start + rowsPerPage;
    return sortedData.slice(start, end);
  }, [sortedData, currentPage, rowsPerPage]);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);
  // Handle page change
  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleInputChange = useCallback(
    (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setSearchInputs((prev) => ({
        ...prev,
        [key]: value,
      }));
      debouncedSetFilters(value, key);
      if (["SourceBranch", "State"].includes(key)) {
        const hash = window.location.hash || '#/';
        const [pathPart, queryPart] = hash.split('?');

        const params = new URLSearchParams(queryPart || '');
        if (value) {
          params.set(key, value);
        } else {
          params.delete(key)
        }

        const newHash = `${pathPart}${params.toString() ? "?" + params.toString() : ""}`;

        window.history.replaceState(null, '', newHash);
        sessionStorage.setItem("prevPath", newHash.split("#")[1])
      }
    },
    [debouncedSetFilters]
  );

  const dynamicColumns = ["Aging"]; // Add more column names if needed
  const createColumn = (key: string, displayName: string) => {
    const columnHeader = (
      <div className="p-2">
        <div className="flex flex-col gap-2 justify-center">
          <div>{displayName}</div>
          <div className="flex items-center justify-center gap-2">
            <input
              type="text"
              value={searchInputs[key] || ""}
              onChange={handleInputChange(key)}
              // placeholder={`Search ${key}`}
              className="border border-gray-300 rounded"
            />
            <button onClick={() => requestSort(key)}>
              <ArrowsUpDownIcon className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    );

    return columnHelper.accessor(key as any, {
      header: columnHeader as any,
      cell: (props: any) => {
        const value = props?.getValue();
        if (
          key === "ReceivedOnServer" ||
          key === "AllocatedOn" ||
          key === "KeyedOn" ||
          key === "FileProcessedDateTime"
        ) {
          return formatDate(value, "dd/MM/yyyy hh:mm:ss a");
        }
        if (dynamicColumns.includes(key)) {
          return convertSecondsToHHMMSS(value);
        }
        return value;
      },
    });
  };

  const columns = useMemo(
    () => [
      columnHelper.display({
        id: "select",
        header: () => (
          <input
            type="checkbox"
            checked={Object.keys(selectedRowIds).length === filteredData.length}
            onChange={() => {
              console.log("checked");
              const allSelected =
                Object.keys(selectedRowIds).length === filteredData.length;
              const newSelectedIds: SelectedRowIds = {};

              if (!allSelected) {
                filteredData.forEach((row) => {
                  console.log(row);
                  newSelectedIds[row.Taskid] = true;
                });
              }
              setSelectedRowIds(newSelectedIds);
            }}
          />
        ),
        cell: (props: any) => (
          <input
            type="checkbox"
            checked={selectedRowIds[props.row.original.Taskid] || false}
            onChange={() => {
              setSelectedRowIds((prev) => {
                const newSelectedRowIds = { ...prev };
                if (newSelectedRowIds[props.row.original.Taskid]) {
                  delete newSelectedRowIds[props.row.original.Taskid];
                } else {
                  newSelectedRowIds[props.row.original.Taskid] = true;
                }
                return newSelectedRowIds;
              });
            }}
          />
        ),
      }),
      createColumn("Taskid", "Task Id"),
      createColumn("Documenttype", "Document Type"),
      createColumn("Cnnumber", "Cn Number"),
      createColumn("ReceiverName", "Receiver Name"),
      createColumn("SourceBranch", "Source Branch"),
      createColumn("State", "State"),
      createColumn("Taskname", "Task Name"),
      createColumn("Receivedonserver", "Received On Server"),
      createColumn("Sme", "SME"),
      createColumn("Exceptioncode", "Exception Code"),
      createColumn("Exceptionreason", "Exception Reason"),
      createColumn("Aging", "Aging"),

      columnHelper.accessor("Actions", {
        header: () => (
          <div
            className="p-2"
            style={{
              position: "sticky",
              right: 0,
              zIndex: 10, // Ensure it's above other content
            }}
          >
            <div className="flex gap-2 justify-center">
              <div>Edit Task</div>
            </div>
          </div>
        ),
        cell: (props: any) => (
          <div
            style={{
              position: "sticky",
              right: 0,
              backgroundColor: "white", // Optional: Prevents background overlap
              zIndex: 10, // Ensure it's above other content
            }}
          >
            <Button
              type="button"
              size="small"
              variant="transparent"
              onClick={() =>
                checkTaskLockResponse(props.row.original.Taskid, true)
              }
              className="text-primary ring-primary hover:bg-orange-100 active:bg-orange-200"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                />
              </svg>
            </Button>
          </div>
        ),
      }),
      columnHelper.display({
        id: "reload",
        header: "Respond",
        cell: (props: any) => (
          <div
            style={{
              position: "sticky",
              right: 0,
              backgroundColor: "white", // Optional: Prevents background overlap
              zIndex: 10, // Ensure it's above other content
            }}
          >
            <Button
              type="button"
              size="small"
              variant="secondary"
              className="text-primary ring-primary hover:bg-orange-100 active:bg-orange-200"
              onClick={() => handleRespondClick(props.row.original.Taskid)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="size-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                />
              </svg>
            </Button>
          </div>
        ),
      }),
    ],
    [
      selectedRowIds,
      columnHelper,
      paginatedData,
      requestSort,
      tableData,
      filters,
      searchInputs,
      debouncedSetFilters,
    ]
  );

  const table = useReactTable({
    data: paginatedData,
    columns: columns as any,

    getCoreRowModel: getCoreRowModel(),
  });

  const exportToExcel = () => {
    const keys = Object.keys(selectedRowIds);
    const selectedData = allData.filter((row) =>
      keys.includes(String(row.Taskid))
    );
    if (selectedData.length === 0) {
      toast.error("No rows selected for export.", {
        theme: "colored",
      });
      return;
    }
    const filteredData = selectedData.map(
      ({
        Taskid,
        Taskname,
        Cnnumber,
        ReceiverName,
        SourceBranch,
        State,
        Receivedonserver,
        Sme,
        Documenttype,
        Exceptioncode,
        Exceptionreason,
        Aging,
      }) => ({
        TaskId: Taskid,
        TaskName: Taskname,
        CNNumber: Cnnumber,
        ReceiverName: ReceiverName,
        SourceBranch: SourceBranch,
        State: State,
        ReceivedOnServer: Receivedonserver,
        SME: Sme,
        DocumentType: Documenttype,
        ExceptionCode: Exceptioncode,
        ExceptionReason: Exceptionreason,
        Aging: convertSecondsToHHMMSS(Aging),
      })
    );

    const headers = [
      "Task Id",
      "Task Name",
      "CN Number",
      "Receiver Name",
      "Source Branch",
      "State",
      "Received On Server",
      "SME",
      "Document Type",
      "Exception Code",
      "Exception Reason",
      "Aging",
    ];

    const worksheet = XLSX.utils.json_to_sheet(filteredData, {
      header: [
        "TaskId",
        "TaskName",
        "CNNumber",
        "ReceiverName",
        "SourceBranch",
        "State",
        "ReceivedOnServer",
        "SME",
        "DocumentType",
        "ExceptionCode",
        "ExceptionReason",
        "Aging",
      ],
    });

    headers.forEach((header, index) => {
      const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: index })]; // Get the cell
      if (cell) {
        cell.v = header;
        cell.s = {
          font: {
            bold: true,
          },
        };
      }
    });

    const colWidths = headers.map((header) => ({ wch: header.length + 5 }));

    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Output Data");

    XLSX.writeFile(workbook, "ExceptionReport.xlsx");
  };

  return (
    <div className="w-full">
      <div className="flex justify-between mb-4">
        <div>
          <label>
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="border rounded p-1 pr-6"
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={sortedData.length}>All</option>
            </select>
          </label>
        </div>

        <button
          onClick={exportToExcel}
          className="bg-orange-500 text-white py-2 px-4 rounded"
        >
          Export to Excel
        </button>
      </div>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 text-center">
          <thead className="bg-gray-50 text-nowrap">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id} className="p-2">
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {table.getRowModel().rows.map((row) => {
              const isDGFCN = row.original.Servicetype === "DGFCN";
              return (
                <tr key={row.id} className={isDGFCN ? "bg-red-200" : ""}>
                  {row.getVisibleCells().map((cell) => (
                    <td
                      key={cell.id}
                      className={`p-2 ${isDGFCN ? "bg-red-200" : ""}`}
                      style={
                        cell.column.id === "Actions" ||
                        cell.column.id === "reload"
                          ? {
                              position: "sticky",
                              right: cell.column.id === "reload" ? 0 : "80px",
                              backgroundColor: "white",
                              zIndex: 10,
                            }
                          : {}
                      }
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center mt-4">
        <div className="p-4">
          {filteredData.length > 0
            ? "Showing " +
              paginatedData.length +
              " of " +
              filteredData.length +
              " entries"
            : "No data available for the selected dates."}
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => handlePageChange(Math.max(currentPage - 1, 0))}
            disabled={currentPage === 0}
            className="border border-gray-300 px-4 py-2 rounded mr-2"
          >
            Previous
          </button>
          <span>
            Page {currentPage + 1} of {totalPages}
          </span>
          <button
            onClick={() =>
              handlePageChange(Math.min(currentPage + 1, totalPages - 1))
            }
            disabled={currentPage >= totalPages - 1}
            className="border border-gray-300 px-4 py-2 rounded ml-2"
          >
            Next
          </button>
        </div>
      </div>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="spinner-border animate-spin border-4 border-orange-400 border-t-transparent w-12 h-12 rounded-full"></div>
        </div>
      )}
      <ResponseModal
        taskid={selectedTaskId}
        isOpen={respondModal}
        onClose={closeRespondModal}
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default ExtractionTable;
